import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Main } from './main';
let root = null;
export const Injector = {
    inject(elementId, props) {
        const container = document.getElementById(elementId);
        root = createRoot(container);
        root.render(_jsx(Main, { ...props }));
    },
    cleanup() {
        root?.unmount();
    }
};
